var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z",
    fill: "#D8E3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6548 5.01733H19.3975C19.0174 5.01733 18.725 5.13429 18.5495 5.51441L16.1519 10.9822H17.8478C17.8478 10.9822 18.1402 10.2513 18.1986 10.0758C18.3741 10.0758 20.0407 10.0758 20.2747 10.0758C20.3331 10.2805 20.4793 10.953 20.4793 10.953H21.9998L20.6548 5.01733ZM18.6665 8.84774C18.8127 8.49687 19.3097 7.18108 19.3097 7.18108C19.3097 7.21032 19.4559 6.8302 19.5144 6.62552L19.6314 7.15184C19.6314 7.15184 19.953 8.58459 20.0115 8.87698H18.6665V8.84774Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692 9.02325C16.2692 10.2513 15.1581 11.07 13.433 11.07C12.702 11.07 12.0002 10.9238 11.6201 10.7484L11.854 9.40337L12.0587 9.49109C12.585 9.72501 12.9359 9.81273 13.5792 9.81273C14.047 9.81273 14.5441 9.63729 14.5441 9.22793C14.5441 8.96477 14.3394 8.78934 13.6961 8.49694C13.0821 8.20454 12.2634 7.73671 12.2634 6.88875C12.2634 5.71916 13.4037 4.92969 15.0119 4.92969C15.626 4.92969 16.1523 5.04665 16.4739 5.19285L16.24 6.4794L16.123 6.36244C15.8306 6.24548 15.4505 6.12852 14.895 6.12852C14.2809 6.15776 13.9885 6.42092 13.9885 6.65483C13.9885 6.91799 14.3394 7.12267 14.895 7.38583C15.8306 7.82442 16.2692 8.3215 16.2692 9.02325Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.07594L2.02924 4.95898H4.54386C4.89474 4.95898 5.15789 5.07594 5.24561 5.45606L5.80117 8.08764C5.24561 6.68413 3.95906 5.54378 2 5.07594Z",
    fill: "#F9B50B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33939 5.01752L6.79553 10.9532H5.07039L3.6084 5.98243C4.66103 6.65495 5.53822 7.70758 5.85986 8.43857L6.0353 9.05261L7.61425 4.98828H9.33939V5.01752Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0117 4.98828H11.6199L10.5965 10.9532H8.98828L10.0117 4.98828Z",
    fill: "#3362AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1366cf0a8d6bfa7e01f31128a647cfd2.svg";
export { ForwardRef as ReactComponent };